<template>
    <div class="desktop:grid
                desktop:grid-cols-12
                gap-4">
        <div class="desktop:col-span-4
                    mb-2 desktop:mb-0">
            <div class="font-bold
                        text-xl desktop:text-2xl
                        leading-snug
                        mb-2">
                {{ title }}
            </div>
            <div v-if="mainVideo">
                <AppVideoPlayer
                    v-bind="mainVideo"
                    width-class="w-full desktop:w-auto widescreen:w-64"
                />
            </div>
            <div v-if="mainImage"
                 :style="`background-image: url(${mainImage})`"
                 class="w-36
                        mx-auto desktop:mx-0
                        mb-2 desktop:mb-0
                        bg-contain
                        bg-center
                        bg-no-repeat"
                 :class="tallerMainImage ? 'h-36': 'h-24'">
            </div>
        </div>
        <div class="desktop:col-span-6
                    mb-4 desktop:mb-0
                    desktop:pr-4
                    text-sm desktop:text-md
                    leading-snug">
            <slot />
        </div>
        <div class="desktop:col-span-2
                    flex
                    flex-row desktop:flex-col
                    justify-between
                    items-end">
            <PricePerMonth :price="price" />
            <slot v-if="$slots.trigger" name="trigger"/>
            <button
                v-else
                @click="$emit('select')"
                :disabled="isSelected"
                class="buyflow-button flex items-center"
            >
                <template v-if="isSelected">
                    <IconCheck class="inline mr-1" />
                    Added
                </template>
                <template v-else>
                    <span data-cy="add-tv" @click="hotJarStateChange">
                        <IconPlus class="inline mr-1" />
                        Add TV
                    </span>
                </template>
            </button>
        </div>
    </div>
</template>

<script>
    import AppVideoPlayer from "~/Buyflow/components/AppVideoPlayer"
    import PricePerMonth from "@/atoms/PricePerMonth"
    import IconCheck from "@/atoms/icons/IconCheck"
    import IconPlus from "@/atoms/icons/IconPlus"

    export default {
        name: 'TVServicesService',
        components: {
            AppVideoPlayer,
            PricePerMonth,
            IconCheck,
            IconPlus,
        },
        props: {
            title: {
                type: String,
                required: true,
                default: null,
            },
            mainImage: {
                type: String,
                default: null,
            },
            tallerMainImage: {
                type: Boolean,
                default: false,
            },
            price: {
                type: Number,
                required: true,
                default: 0,
            },
            isSelected: {
                type: Boolean,
                default: false,
            },
            mainVideo: {
                type: [Object, null],
                default: null,
            },
        },
        methods: {
            hotJarStateChange() {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'hotJarManualStateChange',
                    hotJarPath: 'checkout/tv/addTv'
                })
            },
        },
    }
</script>
